<template>
  <v-layout>
    <v-flex>
      <v-card class="rounded-border justify-center">
        <v-layout row wrap>
          <v-flex>
            <h3 class="font-weight-light headline text-md-center">
              Share the below link
            </h3>
          </v-flex>
        </v-layout>

        <v-card-actions class="justify-center">
          <v-flex>
            <div class="text-center">
              <span class="success--text">{{ $store.state.referralUrl }}</span>
            </div>
          </v-flex>
        </v-card-actions>

        <v-card-text class="justify-center">
          <p class="text-md-center">
            Copy your personal referral link and share it with your friends and
            followers. <br />
            You can earn upto 20% commission of the ordered products by your
            friends. <br />The referral commission will be credited once the
            order is completed. <br />*Terms & Conditions apply.
          </p>
        </v-card-text>
      </v-card>

      <v-flex ma-4>
        <v-simple-table
          :dense="dense"
          :fixed-header="fixedHeader"
          :height="height"
        >
          <template v-slot:no-data>
            <v-alert :value="true" color="error" icon="warning">
              Sorry, nothing to display here :(
            </v-alert>
          </template>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Action</th>
                <th class="text-left">Description</th>
                <th class="text-left">Stats</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in Referral" :key="item.action">
                <td class="text-xs-center font-weight-regular subheading">
                  {{ item.action }}
                </td>
                <td class="text-xs-center font-weight-regular subheading">
                  {{ item.description }}
                </td>
                <td class="text-xs-center font-weight-regular subheading">
                  {{ item.stats }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-flex>
    </v-flex>
  </v-layout>
</template>
<script>
import { db } from "@/Firebase";
export default {
  name: "Referral",
  data: () => ({
    currencySymbol: "INR",
    dense: false,
    fixedHeader: false,
    height: 300,

    Referral: [
      {
        action: "REFERRALS",
        description: "People who have signed up using your link.",
        stats: 0
      },
      {
        action: "COMMISSION",
        description:
          "Maximum Commission Percentage you stand to earn when your referrals order",
        stats: 20
      },
      {
        action: "EARNED",
        description: "Amount that will be applied to your account balance.",
        stats: 0
      },
      {
        action: "PAID",
        description: "Amount that has already been applied to your account.",
        stats: 0
      },
      {
        action: "UNPAID",
        description: "Amount which is yet to be credited to your account.",
        stats: 0
      }
    ]
  }),
  created() {
    if (this.$store.state.referralUrl == "") {
      let refUrl = db.collection("urls").doc(this.$store.state.userId);
      refUrl.get().then(doc => {
        if (doc.exists) {
          let temp = doc.data();
          if (temp.shortUrl != "")
            this.$store.commit("addReferralUrl", temp.shortUrl);
          else this.$store.commit("addReferralUrl", temp.url);
        }
      });
    }
    let refUrl = db.collection("referral").doc(this.$store.state.userId);
    refUrl.get().then(doc => {
      if (doc.exists) {
        let temp = doc.data();
        this.Referral[0].stats = temp.referrals;
        this.Referral[1].stats = temp.commission;
        this.Referral[2].stats = temp.earned;
        this.Referral[3].stats = temp.paid;
        this.Referral[4].stats = temp.unpaid;
      }
    });
  }
};
</script>

<style>
.rounded-border {
  border-radius: 50px;
}
</style>
